// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__OLreP","head":"Table_head__3MUOf","col":"Table_col__Urj8B"};